import React from "react"
import {useAppContextState} from "app/@hooks";
import {createContext} from "use-context-selector";

const Context = createContext({})

const initialState = { tableType: 'dailyPrice' }

export function CompetitionAnalyzerTableTypeProvider({children}) {
    const { state, replaceState } = useAppContextState(initialState)

    return <Context.Provider value={{state, replaceState}}>
        {children}
    </Context.Provider>
}

export default Context